const config = {
  firebase: {
    config: {
      apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
      authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
      databaseURL: process.env.VUE_APP_FIREBASE_DB_DOMAIN,
      projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
      storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
      appId: process.env.VUE_APP_FIREBASE_APP_ID,
      measurementId: process.env.VUE_APP_FIREBASE_MEASURAMENT_ID,
    },
    remoteFetchIntervalMillis: +process.env.VUE_APP_FIREBASE_REMOTE_CONFIG_CACHE_EXPIRE_MILLIS,
    messagingKey: process.env.VUE_APP_FIREBASE_MESSAGE_KEY,
  },
};

export default config;
